var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Triangle-Flag--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Triangle Flag Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "triangle-flag--navigation-map-maps-flag-gps-location-destination-goal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#5dd39e",
    fillRule: "evenodd",
    d: "M2.6658 0.0444946c0.20803 0 0.39628 0.0846974 0.53214 0.2214894L11.8078 4.57093c0.1694 0.08469 0.2764 0.25782 0.2764 0.44721s-0.107 0.36252 -0.2764 0.44721l-8.392 4.19602 0 3.54413c0 0.4142 -0.33578 0.75 -0.75 0.75 -0.41421 0 -0.75 -0.3358 -0.75 -0.75V0.794495c0 -0.414214 0.33579 -0.7500004 0.75 -0.7500004Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIconGreen);
export default __webpack_public_path__ + "static/media/flag-icon-green.19f53be6b1220ff98ff16f65698ef198.svg";
export { ForwardRef as ReactComponent };